import type { SxProps, Theme } from '@mui/material';
import { mergeSx } from 'merge-sx';
import { pillChipSx } from 'charts/common/pillChipSx';
import { Color } from 'shared/utils/colors';

/** Chips in one row, wrapping when they do not fit. */
export const sectionFiltersRowSx: SxProps<Theme> = {
  display: 'flex',
  flexWrap: 'wrap',
  alignItems: 'center',
  gap: 1,
  mb: 3,
};

/** An active filter stands out: tinted, with the brand border. */
export const filterChipSx = (isActive: boolean): SxProps<Theme> =>
  mergeSx(pillChipSx, {
    // Larger and squarer than the chart chip: these are the section's main controls.
    height: 40,
    borderRadius: '8px',
    px: 0.5,
    fontSize: '0.875rem',
    bgcolor: isActive ? Color.primaryOrangeLight : Color.white,
    borderColor: isActive ? Color.primaryOrange : Color.border,
    fontWeight: isActive ? 600 : 500,
    maxWidth: 320,
  });

export const filterPopoverPaperSx: SxProps<Theme> = {
  p: 2,
  width: 360,
  maxWidth: 'calc(100vw - 32px)',
};

export const sectionFiltersClearSx: SxProps<Theme> = {
  textTransform: 'none',
};

export const sectionFiltersMixedInfoSx: SxProps<Theme> = {
  color: Color.iconGray,
  fontSize: '1.25rem',
  ml: 'auto',
};
